namespace SP {
    export interface ToteInfo {
        toteId: number;
        toteName: string;
        toteGroupName: string;
        toteColor: string;
        shipmentId: string;
        orderDeadline: number;
        readyForPack: boolean;
        totePlacementId: number;
        totePlacementName: string;
        totePlacementData: string;
        totePlacementQuantity: number;
        groupPick: boolean;
        picks: ToteItem[];
        pickSettings: PickSettingInfo;
        pickListId: number;
        trolleyId: number;
        trolleyName: string;
        additionalShipmentTotes: ToteInfo[];
        blockPacker: boolean;
        warningInfo: string;
    }
}